<template>
  <VaLayout
    class="h-screen bg-[var(--va-background-secondary)]"
  >
    <template v-if="breakpoint.lgUp" #left>
      <RouterLink
        class="bg-primary h-full flex items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <VuesticLogo :height="28" start="#FFF" />
      </RouterLink>
    </template>
    <template #content>
      <main
        class="h-full flex mx-auto max-w-[420px]"
        :class="breakpoint.lgUp ? 'items-center justify-center' : 'items-center justify-start p-4'"
      >
        <div class="flex flex-col items-start w-full">
          <RouterLink
            v-if="!breakpoint.lgUp"
            class="py-4"
            to="/"
            aria-label="Visit homepage"
          >
            <VuesticLogo class="mb-2" start="#0E41C9" />
          </RouterLink>
          <RouterView />
        </div>
      </main>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui';
import VuesticLogo from '../components/VuesticLogo.vue';

const breakpoint = useBreakpoint();
</script>
